import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=780fd882&scoped=true&"
import script from "./Teacher.vue?vue&type=script&lang=ts&"
export * from "./Teacher.vue?vue&type=script&lang=ts&"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=780fd882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780fd882",
  null
  
)

component.options.__file = "Teacher.vue"
export default component.exports